import CityPageTemplate from "../city-template/CityPageTemplate";
import { fernleyConfig } from "./data";

export default function FernleyPage() {
  return <CityPageTemplate config={fernleyConfig} />;
}